module.exports = __webpack_public_path__ + "static/media/radio-on-white.e0b9e6ea.svg";